import { frontendURL } from 'dashboard/helper/URLHelper';

const PartnerUsers = () => import('./users/Index.vue');
const PartnerChannels = () => import('./channels/Index.vue');
const PartnerBots = () => import('./bots/Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/partner/users'),
      name: 'partner_users',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: PartnerUsers,
    },
    {
      path: frontendURL('accounts/:accountId/partner/channels'),
      name: 'partner_channels',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: PartnerChannels,
    },
    {
      path: frontendURL('accounts/:accountId/partner/bots'),
      name: 'partner_bots',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: PartnerBots,
    },
  ],
};
